<template>
	<div>
		<!-- Commission rule is ratio -->
		<div v-if="commissionType === 'ratio'" class="xs-12 flex xs-middle mt2">
			<div class="xs-4">
				<j-base-input-number v-model="form.amount" @input="onInput" />
			</div>
			<div class="xs-8 p2">% of premium</div>
		</div>

		<!-- Commission rule is flat -->
		<div v-else>
			<!-- Flat UI here -->
		</div>
	</div>
</template>

<script>
/**
 * This component accepts value as a commissionSplit object
 * It will parse the value and understand what commission rule it is and will show proper UI
 */
import JBaseInputNumber from "@/components/JBaseInputNumber"

export default {
	components: { JBaseInputNumber },

	props: {
		value: {
			type: String,
			default: "",
			// Expecting e.g.:
			example: '{ "*": [{var: "totalPremium"},0.85]}'
		}
	},

	data() {
		return {
			form: {
				amount: 0
			}
		}
	},

	computed: {
		commissionType() {
			// TODO: parsing logic and decision about type of rule
			return "ratio" // or flat
		}
	},

	methods: {
		onInput() {
			// Based on commission type emit appropriate payload up
			let payload
			if (this.commissionType === "ratio")
				payload = this.composeRatioRule(this.form.amount)

			// Emit
			this.$emit("input", payload)
		},

		composeRatioRule(amount) {
			return JSON.stringify({
				"*": [
					{
						var: "totalPremium"
					},
					amount / 100 // e.g. 0.85
				]
			})
		},

		getRatioFromCommissionRule(rule) {
			let ruleAsJson

			try {
				ruleAsJson = JSON.parse(rule)
			} catch (e) {
				console.error("Error parsing commission rule to JSON")
			}

			return ruleAsJson?.["*"]?.[1]
				? parseFloat((ruleAsJson?.["*"]?.[1] * 100).toPrecision(6))
				: 0
		}
	},

	watch: {
		value: {
			handler() {
				// Populate amount from commission rule
				if (this.value) {
					if (this.commissionType === "ratio")
						this.form.amount = this.getRatioFromCommissionRule(this.value)
				}
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
